import moment from 'moment';


export function dateToHuman(date) {
    if (!date) {
        return;
    }

    return `à ${moment(date).format('HH:mm:ss')} (${moment(date).fromNow()})`;
}